<template>
	<span class="floatCurrency">
		{{ displayValue }}
		<template v-if="floatCurrency !== null">{{ floatCurrency }}</template>
	</span>
</template>

<script>
export default {
	name: 'floatCurrency',
	data() {
		return {
			/**
			 * Значение
			 */
			floatValue: 0,
			/**
			 * Валюта
			 */
			floatCurrency: null,
			/**
			 * Точность
			 */
			floatPrecision: 2,
		};
	},
	props: {
		value: {
			type: [String, Number],
			required: true,
		},
		currency: {
			type: [String],
			required: false,
		},
		precision: {
			required: false,
			default: 2,
		},
	},
	mounted() {
		this.floatValue = this.value;
		this.floatCurrency = this.currency;
		this.floatPrecision = this.precision;
	},
	watch: {
		/**
		 * Изменение значения
		 */
		value(newValue) {
			this.floatValue = newValue;
		},

		/**
		 * Изменение валюты
		 */
		currency(newValue) {
			this.floatCurrency = newValue;
		},

		/**
		 * Изменение точности
		 * @param newValue
		 */
		precision(newValue) {
			this.floatPrecision = parseInt(newValue);

			if (newValue === null || typeof newValue === 'undefined') {
				this.floatPrecision = 2;
			}
		},
	},
	computed: {
		displayValue() {
			let result = '0';
			if (this.floatValue !== null) {
				result = new Intl.NumberFormat('ru-RU',
					{style: 'decimal', maximumFractionDigits: this.floatPrecision}).format(
					parseFloat(this.floatValue));
			}

			return result.replace(',', '.');
		},
	},
};
</script>

<style scoped>
.floatCurrency {
	font-size: inherit;
}
</style>